import {deprecatedTrackEvent} from 'analytics/Analytics';
import {INSIGHTS_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';

export default function trackOnCopy(): void {
  deprecatedTrackEvent(INSIGHTS_ANALYTICS_ACTIONS.COPIED_TABLE_NAME_IN_SCHEMA_BROWSER);
}
